import { render } from "./BusinessInformation.vue?vue&type=template&id=39bd0c01&scoped=true&ts=true"
import script from "./BusinessInformation.vue?vue&type=script&lang=ts"
export * from "./BusinessInformation.vue?vue&type=script&lang=ts"

import "./BusinessInformation.vue?vue&type=style&index=0&id=39bd0c01&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bd0c01"]])

export default __exports__